import { render, staticRenderFns } from "./DnsDelete.vue?vue&type=template&id=23a9ddb4&scoped=true"
import script from "./DnsDelete.vue?vue&type=script&lang=js"
export * from "./DnsDelete.vue?vue&type=script&lang=js"
import style0 from "./DnsDelete.vue?vue&type=style&index=0&id=23a9ddb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a9ddb4",
  null
  
)

export default component.exports